// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import { universitiesList } from './Universities'
import LazyImage from './components/lazyImage.jsx';
import ProjectMenu from './Project'
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';

class ProjectEs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {



    }

    onToggleTab = (value) => {
        this.setState({ currentTab: value })
    }

    render() {

        return (

            <div className={`flex-col`}>
                <Header activeMenu='6' />
                <div className='dv_project_body'>
                    <ProjectMenu activeMenu={2} />
                    <div className='dv_project_body_right'>
                        <div className={`flex-col`}>
                            <div className='dv_banner_wrap'><img src={require("./assets/img/projects/12.png")} /></div>
                            <div className='dv_contentbodyEs_wrap'>
                                <div className='dv_trake_change flex-row between'>
                                    <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>走进UPC EUNCET</div>
                                    <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>官方本科专业介绍</div>
                                    <div className={this.state.currentTab == 2 ? 'tab selected tablast' : 'tab clickable'} onClick={() => this.onToggleTab(2)}>官方硕士专业介绍</div>
                                </div>
                                {this.state.currentTab == 0 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/projects/13.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/14.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/15.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/16.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/17.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/18.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/19.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/20.jpg")} />
                                    </div>

                                </div>}
                                {this.state.currentTab == 1 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/projects/21.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/22.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/23.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/24.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/25.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/26.jpg")} />
                                    </div>

                                </div>}
                                {this.state.currentTab == 2 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/projects/27.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/28.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/29.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/30.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/31.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/32.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/32.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/33.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/34.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/35.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/36.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/37.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/38.jpg")} />
                                    </div>

                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>

        );
    }
}

export default withRouter(ProjectEs);